import {
  CursorPaginationSchema,
  adminApi,
  apiEndpoint,
  cursorPaginatedResponse,
} from "@core/ports/http";
import { z } from "@core/zod";

import { API_DOMAIN } from "@platform/core";

import { BILLING_SERVICE } from "../config/index.ts";
import { Balance, Transaction } from "../models/index.ts";

const MAX_TOP_UP_AMOUNT = 10;

export const billingAdminApi = adminApi(
  { domain: API_DOMAIN, path: `${BILLING_SERVICE.LABEL}/admin` },
  {
    getBalance: apiEndpoint({
      body: z.object(
        { principalId: Balance.shape.principalId },
        { principalId: Balance.descriptions.principalId },
      ),
      response: z.object(
        {
          available: z.decimal(),
          balances: z.array(Balance.schema),
          reserved: z.decimal(),
          total: z.decimal(),
        },
        {
          available: "The credit left to spend, the total less the reserved",
          balances: "The principal's active balances",
          reserved: "The credit the pending reservations hold",
          total: "The credit the active balances hold together",
        },
      ),
    }),
    getTransactions: apiEndpoint({
      body: z.object(
        {
          ...CursorPaginationSchema.shape,
          principalId: Transaction.shape.principalId,
        },
        {
          ...CursorPaginationSchema.descriptions,
          principalId: Transaction.descriptions.principalId,
        },
      ),
      response: cursorPaginatedResponse(Transaction.schema),
    }),
    topUp: apiEndpoint({
      body: z.object(
        {
          amount: z.decimal().positive().lte(MAX_TOP_UP_AMOUNT),
          description: Balance.shape.description,
          expiresAt: Balance.shape.expiresAt,
          principalId: Balance.shape.principalId,
        },
        {
          amount: "The credit the top-up grants, as a decimal string",
          description: Balance.descriptions.description,
          expiresAt: Balance.descriptions.expiresAt,
          principalId: Balance.descriptions.principalId,
        },
      ),
      response: z.object(
        { balance: Balance.schema },
        { balance: "The balance the top-up created" },
      ),
    }),
  },
);
